import {createAction, props} from '@ngrx/store';

import {Translation, TranslationInput} from './translation.model';
import {Update} from "@ngrx/entity";

export const loadTranslations = createAction(
  '[Translation/API] Load Translations',
  props<{ translations: Translation[] }>()
);

export const addTranslation = createAction(
  '[Translation/API] Add Translation ',
  props<{ translation: Translation }>()
);

export const upsertTranslation = createAction(
  '[Translation/API] Upsert Translation ',
  props<{ translation: Translation }>()
);

export const addTranslations = createAction(
  '[Translation/API] Add Translations',
  props<{ translations: Translation[] }>()
);

export const upsertTranslations = createAction(
  '[Translation/API] Upsert Translations',
  props<{ translations: Translation[] }>()
);

export const updateTranslation = createAction(
  '[Translation/API] Update Translation ',
  props<{ translation: Update<Translation> }>()
);

export const updateTranslations = createAction(
  '[Translation/API] Update Translations',
  props<{ translations: Update<Translation>[] }>()
);

export const deleteTranslation = createAction(
  '[Translation/API] Delete Translation ',
  props<{ id: number }>()
);

export const deleteTranslations = createAction(
  '[Translation/API] Delete Translations',
  props<{ ids: string[] }>()
);

export const clearTranslations = createAction(
  '[Translation/API] Clear Translations'
);

// Effects actions

export const saveTranslation = createAction(
  '[Translation/API] Save Translation ',
  props<{ input: TranslationInput[], goBack?: boolean }>()
);

export const removeTranslation = createAction(
  '[Translation/API] remove Translations',
  props<{ keyword: string; id: number; }>()
);

export const getTranslations = createAction(
  '[Translation/API] get Translations',
  props<{ filtering?: any }>()
);

